const cueSet2 = [
    {
        "duration": 9.411760000000001,
        "durationTicks": 245760,
        "midi": 53,
        "name": "F3",
        "ticks": 491520,
        "time": 18.823520000000002,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 9.411760000000001,
        "durationTicks": 245760,
        "midi": 53,
        "name": "F3",
        "ticks": 737280,
        "time": 28.235280000000003,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 9.411760000000001,
        "durationTicks": 245760,
        "midi": 53,
        "name": "F3",
        "ticks": 983040,
        "time": 37.647040000000004,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 9.411760000000001,
        "durationTicks": 245760,
        "midi": 53,
        "name": "F3",
        "ticks": 1228800,
        "time": 47.058800000000005,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 9.411760000000001,
        "durationTicks": 245760,
        "midi": 53,
        "name": "F3",
        "ticks": 1228800,
        "time": 56.458800000000005,
        "velocity": 0.7874015748031497
    }
];

export default cueSet2;
